import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import $ from "jquery";
import { noticedata } from "../utils/NoticePageApi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Accordion } from 'react-bootstrap';
const LatestNoticeNoticePage = () => {
  let navigate = useNavigate();

  useEffect(() => {
    $(function noticehover() {
      let x, y;
      $(".noticebox").on("mouseenter", function (e) {
        x = e.pageX - $(this).offset().left;
        y = e.pageY - $(this).offset().top;
        $(this).find("span").css({
          top: y,
          left: x,
        });
      });
      $(".noticebox").on("mouseout", function (e) {
        x = e.pageX - $(this).offset().left;
        y = e.pageY - $(this).offset().top;
        $(this).find("span").css({
          top: y,
          left: x,
        });
      });
    });
  }, []);

  const handleNoticeSinglePage = (id) => {
    navigate(`/notice/latest/${id}`);
  };

  const headers = {
    "X-localization": localStorage.getItem("lan"),
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Max-Age": 3600,
  };

  const [NoticeId, setNoticeId] = useState("");
  const [NoticeHeader, setNoticeHeader] = useState("");
  const [NoticeBody, setNoticeBody] = useState("");
  const [NoticeDate, setNoticeDate] = useState("");
  const [myresponse, setmyResponse] = useState([]);

  useEffect(() => {

    const fetchLatestNotice = async () => {
      try {
        const myresponse = await axios.get("https://sass.britishstandardschool.com/api/Public/LatestNotice", {}, headers);
        setmyResponse(myresponse.data)
      } catch (err) {
        if (err.response) {
          console.error(err.response.data);
          console.log(err.response.status);
          console.log(err.response.header);
        } else {
          console.error(`Error: ${err.message}`);
        }
      }
    };

    fetchLatestNotice();
    console.log(myresponse);
  }, []);
  const [activeKey, setActiveKey] = useState(null);
  const handleAccordionToggle = (eventKey) => {
    setActiveKey(eventKey);
    // eventKey == activeKey ? null : 
};

  return (
    <>
    

      <div className="latestNoticepart" id="latestNoticepart">
        <div className="myContainerMini">
          <div className="subheadingandparagraph" data-aos-delay="600" data-aos="fade-in" data-aos-duration="1000">
            <h3>Latest</h3>
          </div>
          <Row className="noticecontent" data-aos-delay="300" data-aos="fade-up" data-aos-duration="1000">
            <div className="myContainermini">
              {
                myresponse.map((item, key) => {
                  // let trimmedString= item.paragraph  
                  // .substr(0, 38)
                  return (
                    <Col lg={12} md={12} key={key}>

                      <Accordion onSelect={handleAccordionToggle} className='myaccordionnotice  noticeboxleft hoverscale' defaultActiveKey="0" key={key}>
                        <Accordion.Item style={activeKey == key ? { border: "1px solid rgba(0,0,0,0.7)" } : { border: "1px solid rgba(0,0,0,0.2)" }} eventKey={`${key}`}>
                          <Accordion.Header>
                            <div className="myacchead">
                              <div className="noticetabboxbarbig">
                                <div className="dateofnoticebox">

                                </div>
                                <h3>{item.header}</h3>
                                <div className="lastrow d-flex">
                                  <img src="./assets/images/icons/cal27.png" alt="" />
                                  <p>{item.noticeDate}</p>
                                </div>
                              </div>
                            </div>
                          </Accordion.Header>
                          <Accordion.Body className='accbody'>
                            {/* <p>{trimmedString}...</p> */}
                            <p>{item.body}</p>

                          </Accordion.Body>
                        </Accordion.Item>

                      </Accordion>

                    </Col>

                  )
                })
              }
            </div>

          </Row>
        </div>
      </div>
    </>
  );
};

export default LatestNoticeNoticePage;
